module.exports = __webpack_public_path__ + "img/root00.af8ea8b0.png";